import { MY_QA } from "../constants/ActionTypes";

const initialQAState = {
    MY_QA_LIST_PAGE : null
};

export default function ( state = initialQAState, action = {} ){

    switch( action.type ){
        //列表页码
        case MY_QA.MY_QA_LIST_PAGE:
            return Object.assign({},state,{
                MY_QA_LIST_PAGE : action.MY_QA_LIST_PAGE
            });
            break;

        default:
            return state;break;
    }
}


// WEBPACK FOOTER //
// ./common/reducers/myAccountQA.js